import { queryBuilder } from '@contember-cloud/studio-client';
export const PluginReleaseWithId = queryBuilder.fragment('PluginRelease', it => it.$$());
export const PluginWithAll = queryBuilder.fragment('Plugin', it => it.$$().$('activeRelease', PluginReleaseWithId));
export const PluginReleaseWithAll = queryBuilder.fragment('PluginRelease', it => it.$$().$('plugin', PluginWithAll));
export const queryGetPlugin = (uniqueQueryInput) => {
    return queryBuilder.get('Plugin', uniqueQueryInput, () => PluginWithAll);
};
export const queryGetPluginRelease = (uniqueQueryInput) => {
    return queryBuilder.get('PluginRelease', uniqueQueryInput, () => PluginReleaseWithAll);
};
//# sourceMappingURL=queryGetPlugin.js.map